export function ticketsExt($form)
{
    function customButtonsQty($selector) {

        var $this = $selector;
        $this.before('<span class="custom-minu">-</span>');
        $this.after('<span class="custom-plus">+</span>');

        // Plus
        $this.siblings('.custom-plus').click(function(){
            var getCurrentValue =  $this.val();
            var getCurrentValueNew = parseInt(getCurrentValue)+1;
            if(getCurrentValueNew > $this.attr('max')){
                console.log('Limit has be reached !!');
            } else {
                $this.val(getCurrentValueNew);
            }
        });

        //Minus
        $this.siblings('.custom-minu').click(function(){
            var getCurrentValue =  $this.val();
            var getCurrentValueNew = parseInt(getCurrentValue)-1;
            if (getCurrentValueNew < 0) {
                console.log('Limit has be reached !!');
            } else {
                $this.val(getCurrentValueNew);
            }
        });
    }

    function actions(){
        $(document).ready(function () {
            $($form).map(function (){
                customButtonsQty($(this));
            });
        });
    }

    actions();
}


// WEBPACK FOOTER //
// ./assets/js/modules/tickets.js